var _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup98(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 84,
    viewBox: "0 0 69 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6629,
    cy: 11.441,
    r: 3,
    transform: "rotate(40.9501 53.6629 11.441)",
    fill: "#212931"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4735,
    cy: 36.4781,
    r: 3,
    transform: "rotate(40.9501 50.4735 36.4781)",
    fill: "#212931"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4149,
    cy: 30.6666,
    r: 3,
    transform: "rotate(40.9501 22.4149 30.6666)",
    fill: "#212931"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.82893,
    cy: 74.941,
    r: 3,
    transform: "rotate(40.9501 7.82893 74.941)",
    fill: "#212931"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1703 31.3225L53.6622 11.4417L50.8503 36.8059M23.1703 31.3225L50.8503 36.8059M23.1703 31.3225L7.22236 76.402L50.8503 36.8059",
    stroke: "#212931",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup98);
export default __webpack_public_path__ + "static/media/Group 98.7eee6ca8918f184bb99397ed58e15a74.svg";
export { ForwardRef as ReactComponent };